/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMostViewedProjectsQueryVariables = Types.Exact<{
  input: Types.GetCampaignViewsInput;
}>;


export type GetMostViewedProjectsQuery = { __typename: 'Query', getCampaignViews: Array<{ __typename: 'GetCampaignViewsResponse', views: number, campaign: { __typename: 'Campaign', id: string | null, name: string | null, label_id: string | null, owner_id: number | null, active: boolean | null, artist: { __typename: 'Artist', name: string | null, facebook_id: string | null, spotify_id: string | null } | null } }> };


export const GetMostViewedProjectsDocument = gql`
    query GetMostViewedProjects($input: GetCampaignViewsInput!) {
  getCampaignViews(input: $input) {
    views
    campaign {
      id
      name
      label_id
      owner_id
      active
      artist {
        name
        facebook_id
        spotify_id
      }
    }
  }
}
    `;

/**
 * __useGetMostViewedProjectsQuery__
 *
 * To run a query within a React component, call `useGetMostViewedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostViewedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostViewedProjectsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMostViewedProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetMostViewedProjectsQuery, GetMostViewedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMostViewedProjectsQuery, GetMostViewedProjectsQueryVariables>(GetMostViewedProjectsDocument, options);
      }
export function useGetMostViewedProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMostViewedProjectsQuery, GetMostViewedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMostViewedProjectsQuery, GetMostViewedProjectsQueryVariables>(GetMostViewedProjectsDocument, options);
        }
export type GetMostViewedProjectsQueryHookResult = ReturnType<typeof useGetMostViewedProjectsQuery>;
export type GetMostViewedProjectsLazyQueryHookResult = ReturnType<typeof useGetMostViewedProjectsLazyQuery>;